import React, {Component} from 'react';
import {Spinner} from "./Spinner";

export class SpinnerButton extends Component {
    render() {
        return (
            <div className="loading-save-button">
                <Spinner color="negative very-small"/>
            </div>
        )
    }
}